
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"74","height":"75","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M70.081 45.755h.421V71.42H37.52V54.508h.45c.545 0 1.05-.174 1.46-.47.41.296.915.47 1.46.47h4.381c.545 0 1.05-.174 1.46-.47.411.296.916.47 1.46.47h4.382a2.5 2.5 0 002.5-2.5V49.09c0-.544-.175-1.048-.47-1.458.295-.41.47-.915.47-1.46v-.452c.136.023.277.035.42.035h4.381a2.49 2.49 0 001.46-.47c.411.296.915.47 1.46.47h4.382c.541 0 1.043-.172 1.453-.465.409.293.91.465 1.452.465z","fill":"#413E3E","stroke":"#413E3E","stroke-width":"5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M68.649 15.523v2.918a1.473 1.473 0 01-1.475 1.473H39.428v8.738h8.74a1.476 1.476 0 011.475 1.474v5.835a1.473 1.473 0 01-1.453 1.489H27.746a1.476 1.476 0 01-1.475-1.474v-5.835a1.473 1.473 0 011.475-1.474l40.903-13.144zm0 0a1.45 1.45 0 00-.212-.76m.212.76l-.212-.76m0 0a1.452 1.452 0 00-.578-.537l.578.537zM48.143 35.95H27.77v-5.783h10.236v-.015h10.136v5.798zM38.007 18.414H11.635v.004H1.5v-2.882l4.236-4.345h5.899v.011h8.756l-.01-.014H58.67l8.479 4.36v2.866H38.008zM7.327 65.183h2.8l-.007.007h10.354v-.007H24.8v7.24H7.326v-7.24z","fill":"#1BBAC8","stroke":"#413E3E","stroke-width":"3"}})])
          )
        }
      }
    